import { getUserConfiguration } from 'owa-session-store';
import getHashString from 'bookings-shared/lib/c2/utils/getHashString';

export default function getLoggedInUserHashedEmail(): string {
    const emailAddress = getUserConfiguration().SessionSettings?.LogonEmailAddress ?? '';
    return getHashString(emailAddress);
}
